import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SpAuthService } from './utility-services';
import { PersonalInfoUpdateRequest, PersonalInfoUpdateResponse } from '..';
import { Observable } from 'rxjs';
import { personalInfoUpdateUrl } from './constants';

@Injectable({ providedIn: 'root' })
export class PersonalInfoService {
  constructor(private http: HttpClient, private auth: SpAuthService) {}

  public updatePersonalInfo(
    request: PersonalInfoUpdateRequest
  ): Observable<PersonalInfoUpdateResponse> {
    const url = `${personalInfoUpdateUrl}`;

    const headers = { 'content-type': 'application/json' };
    const body = JSON.stringify(request);
    return this.http.put<PersonalInfoUpdateResponse>(url, body, { headers: headers });
  }
}
